import { render } from "./StepRegistrationSuccess.vue?vue&type=template&id=749b0f42"
import script from "./StepRegistrationSuccess.vue?vue&type=script&lang=js"
export * from "./StepRegistrationSuccess.vue?vue&type=script&lang=js"

import "./StepRegistrationSuccess.vue?vue&type=style&index=0&id=749b0f42&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__